import { Button, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { FadeOutSpacer } from '../components';
import { ICON_CONTAINER_WIDTH, TRANSITION_SETTINGS } from '../config';
export const StyledButton = styled(Button) `
  justify-content: flex-start;
  min-width: ${ICON_CONTAINER_WIDTH};
  width: 100%;
  padding: 0;
  gap: 0;
  transition: all ${TRANSITION_SETTINGS};
`;
export const StyledFadeOutSpacer = styled(FadeOutSpacer) `
  padding-right: ${theme.spacing.md};
`;
